var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"venta-online"}},[_c('collapse-row',{attrs:{"title":"Gastos envio online"}},[_c('template',{slot:"content"},[_c('DataTable',{attrs:{"items":_vm.items,"fields":_vm.fields,"itemsPerPage":5}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }